export const enumDeliveryResultType = {
    unknown: 0,
    email: 1,
    phone: 2,
    sms: 4,
    letter: 5,
  }